import { IProduct } from 'featureSliced/shared/store/reducers/CategoriesReducer/types'
import { ModalProps } from 'featureSliced/shared/store/reducers/ModalsReducer/types'
import { useOpenModal } from 'featureSliced/shared/hooks/useOpenModal'
import { AddCommonProduct } from './modals/AddCommonProduct'
import { AddMenuItemsProduct } from './modals/AddMenuItemsProduct'
import { AddMenuItems } from './modals/AddMenuItems'
import { AddSubTemplateProduct } from './modals/AddSubTemplateProduct'
import { useGetTranslatedNames } from '../../useGetTranslatedNames'
import { useMySelector } from 'featureSliced/shared/hooks/useMySelector'
import { ProductTemplateIdType } from 'featureSliced/shared/store/reducers/QRMenuBucketReducer/types'

export type OpenProductModalType = (
  product: IProduct,
  productTemplateId: ProductTemplateIdType
) => void

export const useOpenProduct = (): OpenProductModalType => {
  const openModal = useOpenModal()
  const { getProductName } = useGetTranslatedNames()
  const openProductModal = (
    product: IProduct,
    productTemplateId: ProductTemplateIdType
  ) => {
    const innerCategoryItems = product.innerCategoryItems
    console.log('🚀 ~ product:', product)

    const isCommonProduct =
      !innerCategoryItems?.length && !product.menus?.length
    const isSubtemplate = innerCategoryItems?.length
    const isMenuItems = product.menus?.length && !innerCategoryItems?.length

    openModal({
      id: `ADD_PRODUCT_${product.id}`,
      title: isSubtemplate ? getProductName(product) : undefined,
      components: [
        ...(isCommonProduct
          ? [
              ({ closeThisModal }: ModalProps) => (
                <AddCommonProduct
                  product={product}
                  productTemplateId={productTemplateId}
                  closeProduct={closeThisModal}
                />
              ),
            ]
          : []),
        ...(isSubtemplate
          ? [
              ({ closeThisModal }: ModalProps) => (
                <AddSubTemplateProduct
                  products={product.innerCategoryItems}
                  productTemplateId={productTemplateId}
                  closeModal={closeThisModal}
                />
              ),
            ]
          : []),
        ...(isMenuItems
          ? [
              ({ onNext }: ModalProps) => (
                <AddMenuItemsProduct
                  product={product}
                  productTemplateId={productTemplateId}
                  onNext={onNext}
                />
              ),
              ({ closeThisModal, onNext, onPrev, ...props }: ModalProps) => (
                <AddMenuItems
                  product={product}
                  productTemplateId={productTemplateId}
                  closeModal={closeThisModal}
                  {...props}
                />
              ),
            ]
          : []),
      ],
    })
  }

  return openProductModal
}
